export const DROPDOWN = "WORLD_CUP_DROPDOWN";
export const STORE = "WORLD_CUP_STORE";